var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome-screen text-center safe-area"},[_c('h1',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('img',{staticClass:"bottom",attrs:{"src":require("../../assets/WelcomeToScan/bottom.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }